import { render } from "./HeadquartersContent.vue?vue&type=template&id=ca075506&ts=true"
import script from "./HeadquartersContent.vue?vue&type=script&lang=ts"
export * from "./HeadquartersContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__